import { createActionGroup, props } from "@ngrx/store";
import { NavigationPoints } from "@enum";

export const RootActions = createActionGroup({
  source: "Root",
  events: {
    "Navigate to Page": props<{ page: NavigationPoints }>(),
  },
});
